import React from 'react'
import Service from './Service'

export default function index() {
  return (
    <Service/>
  )
}
